import { api } from "./dataService";

export const fetchConnectors = async () => {
  return (await api.get("data/import-connectors")).data;
};

export const fetchConnector = async (connector_id) => {
  return (await api.get(`data/import-connectors/${connector_id}`)).data;
};

export const createConnector = async (payload) => {
  return (await api.post("data/import-connectors", payload)).data;
};

export const updateConnector = async (connector_id, payload) => {
  return (await api.patch(`data/import-connectors/${connector_id}`, payload)).data;
};

export const deleteConnector = async (connector_id) => {
  await api.delete(`data/import-connectors/${connector_id}`);
};
